import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';
import {ReportRoutingModule} from '../routes/report-routing.module'
import { ReportMainComponent,LabReportComponent } from '../components';
import { NgSelectModule } from '@ng-select/ng-select';


@NgModule({
  declarations: [
    ReportMainComponent,
    LabReportComponent
  ],
  exports: [
    ReportMainComponent,
    LabReportComponent
  ],
  imports: [
    SharedModule,
    ReportRoutingModule,
    NgSelectModule
    ],
})
export class ReportModule { }
